import type { RoleConfig } from '../types.js';

export const busDriver: RoleConfig = {
  id: 'bus_driver',
  faction: 'town',
  title: { ru: 'Водитель', uk: 'Водій' },
  latin: 'BUS DRIVER',
  number: '16',
  accent: '#e8a64a',
  ability: {
    ru: 'Ночью меняет местами двух игроков — все ночные действия, направленные на одного, попадают в другого.',
    uk: 'Вночі міняє місцями двох гравців — усі нічні дії, спрямовані на одного, потрапляють на іншого.',
  },
  abilities: [
    {
      key: 'redirect',
      phase: 'night',
      cadence: 'every-night',
      shape: 'two-target',
      canSelfTarget: true,
    },
  ],
  victory: { type: 'town' },
};
